// removed by extract-text-webpack-plugin
module.exports = {"container":"Gfe2f26","recipe":"G507d48","recipeContainer":"G3e4dc7"};